import { STOREMODULE_ENDPOINTMODULE_MAP } from '@/assets/js/config/server'

import { TOASTER_OPTIONS } from '@/assets/js/config/client'

import Vue from 'vue'
import http from '@/$plugins/http'

import base from '../base'
import ENTITY from '../base/entity'
import IS from '../base/is'

const ENTITY_KEY = 'endcustomerendusers'
const SERVER_ENTITY_NAME = 'EndUser'

export default {
  namespaced: true,
  state: base.createState(IS.state, ENTITY.state, {
    byEndCustomerId: {},
    notesByEndUserId: {}
  }),
  getters: base.createGetters(IS.getters, ENTITY.getters, {
    getByEndCustomerId: state => endCustomerId => state.byEndCustomerId[endCustomerId] || [],
    getNotesByEndUserId: state => endUserId => state.notesByEndUserId[endUserId] || []
  }),
  mutations: base.createMutations(IS.mutations, ENTITY.mutations, {
    setByEndCustomerId (state, { endCustomerId, endUserIds }) {
      state.byEndCustomerId = Object.assign({}, state.byEndCustomerId, { [endCustomerId]: endUserIds })
    },
    setNotesByEndUserId (state, { endUserId, notes }) {
      state.notesByEndUserId = Object.assign({}, state.notesByEndUserId, { [endUserId]: notes || [] })
    },
    removeNoteByEndUserId (state, { endUserId, note }) {
      const notes = (state.notesByEndUserId[endUserId] || []).slice()
      const idx = notes.findIndex(n => n.id === (note || {}).id)
      if (idx >= 0) notes.splice(idx, 1)
      state.notesByEndUserId = Object.assign({}, state.notesByEndUserId, { [endUserId]: notes })
    }
  }),
  actions: base.createEntityActions(
    STOREMODULE_ENDPOINTMODULE_MAP.customer,
    SERVER_ENTITY_NAME,
    IS.actions,
    ENTITY.actions,
    {
      getByEndCustomerId (serverModuleName = '', serverEntityName = '', entityKey = '') {
        const isKey = `${serverEntityName}/getByEndCustomerId`

        return function ({ getters, commit, dispatch }, endCustomerId = '') {
          commit('setLoading', { key: isKey, loading: true, initial: true })
          dispatch('getDefinition')

          return new Promise(resolve => {
            http({
              method: 'get',
              url: `/${serverModuleName}/api/${SERVER_ENTITY_NAME}/ByEndCustomerId/${endCustomerId}`
            })
              .then(response => {
                const entities = response.data.result || []
                const ids = entities.map(e => e.id)

                // Keep the entity store in sync so consumers can use getEntity/getEntityUnwrapped.
                ids.forEach((id, i) => {
                  commit('setEntity', { key: ENTITY_KEY, entity: entities[i] })
                })

                commit('setByEndCustomerId', { endCustomerId, endUserIds: ids })
                resolve(getters.getByEndCustomerId(endCustomerId))
              })
              .finally(() => {
                commit('setLoading', { key: isKey, loading: false })
              })
          })
        }
      },
      getNotes (serverModuleName = '', serverEntityName = '', entityKey = '') {
        const isKey = `${serverEntityName}/getNotes`

        return function ({ getters, commit }, endUserId = '') {
          commit('setLoading', { key: isKey, loading: true, initial: true })

          return new Promise(resolve => {
            http({
              method: 'get',
              url: `/${serverModuleName}/api/${SERVER_ENTITY_NAME}/${endUserId}/notes`
            })
              .then(response => {
                commit('setNotesByEndUserId', { endUserId, notes: response.data.result })
                resolve(getters.getNotesByEndUserId(endUserId))
              })
              .finally(() => {
                commit('setLoading', { key: isKey, loading: false })
              })
          })
        }
      },
      createNote (serverModuleName = '', serverEntityName = '', entityKey = '') {
        const isKey = `${serverEntityName}/createNote`

        return function ({ getters, commit }, options = {}) {
          commit('setSending', { key: isKey, sending: true })

          return new Promise(resolve => {
            http({
              method: 'post',
              url: `/${serverModuleName}/api/${SERVER_ENTITY_NAME}/${options.entityId}/notes`,
              data: options.note
            })
              .then(response => {
                commit('setNotesByEndUserId', { endUserId: options.entityId, notes: response.data.result })
                resolve(getters.getNotesByEndUserId(options.entityId))
                if (Vue.$app.$bvToast) Vue.$app.$bvToast.toast(Vue.$app.$i18n.t('entity.apiactions.created'), Object.assign({}, TOASTER_OPTIONS.api.options.send, { title: `API ${SERVER_ENTITY_NAME}` }))
              })
              .finally(() => {
                commit('setSending', { key: isKey, sending: false })
              })
          })
        }
      },
      removeNote (serverModuleName = '', serverEntityName = '', entityKey = '') {
        const isKey = `${serverEntityName}/removeNote`

        return function ({ commit }, options = {}) {
          commit('setSending', { key: isKey, sending: true })

          return new Promise(resolve => {
            http({
              method: 'delete',
              url: `/${serverModuleName}/api/${SERVER_ENTITY_NAME}/${options.entityId}/notes/${options.note.id}`
            })
              .then(() => {
                commit('removeNoteByEndUserId', { endUserId: options.entityId, note: options.note })
                resolve()
                if (Vue.$app.$bvToast) Vue.$app.$bvToast.toast(Vue.$app.$i18n.t('entity.apiactions.removed'), Object.assign({}, TOASTER_OPTIONS.api.options.send, { title: `API ${SERVER_ENTITY_NAME}` }))
              })
              .finally(() => {
                commit('setSending', { key: isKey, sending: false })
              })
          })
        }
      }
    }
  )
}

